document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hero-slider').forEach(function (sliderEl) {
    var autoplaySeconds = parseInt(sliderEl.dataset.autoplay, 10) || 5;

    var swiper = new Swiper(sliderEl.querySelector('.hero-swiper'), {
      loop: true,
      autoplay: {
        delay: autoplaySeconds * 1000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: sliderEl.querySelector('.hero-swiper-next'),
        prevEl: sliderEl.querySelector('.hero-swiper-prev')
      },
      pagination: {
        el: sliderEl.querySelector('.hero-swiper-pagination'),
        clickable: true
      },
      touchRatio: 1,
      grabCursor: true
    });
  });
});